module.exports = __webpack_public_path__ + "img/f97a33c.png";